import { Record } from "immutable";

export const Notification = Record({
  message: "",
  color:  "info",
  dismiss: 7000,
  closeable: true
})
